document.addEventListener('DOMContentLoaded', function () {
  const blogPost = document.getElementById('blog-post')
  if (blogPost && hasQueryParams(window.location.href)) {
    blogPost.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
  }

  function hasQueryParams(url) {
    return url.includes('?')
  }
})
